import { AppError, EAppErrorKind } from '@/utils/error';
import { toAppError } from './appError';

export type AppErrorHandler = (error: AppError) => void;

/**
 * default 由类型系统强制,任何错误都必然被某个分支接住,不会漏分发。
 * 但「接住」不等于「提示」—— 分支里做什么由调用点决定,写 `() => {}` 依然是静默吞错。
 */
export type AppErrorHandlers = Partial<Record<EAppErrorKind, AppErrorHandler>> & {
  default: AppErrorHandler;
};

/**
 * 按 kind 查表分发,无可变状态,因此与书写顺序无关。
 * @returns 归一化后的错误,便于调用方继续做日志等处理
 */
export function matchError(error: unknown, handlers: AppErrorHandlers): AppError {
  const appError = toAppError(error);
  const handler = handlers[appError.kind] ?? handlers.default;
  handler(appError);
  return appError;
}
